import type {Shortcut} from '@github-ui/code-view-shared/hooks/shortcuts'

export function KeyboardVisual({shortcut}: {shortcut: Shortcut}) {
  return (
    <span className="d-flex gap-1">
      {shortcut.text?.split(' ').map((keyValue, idx) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <kbd key={`${keyValue}-${idx}`}>{keyValue}</kbd>
      ))}
    </span>
  )
}
